export default __webpack_public_path__ + "static/media/photo--lg--16.6103de14.jpg";